import { useCallback, useState } from 'react';
import { ProfileApi } from '@shared/api';

export const useAddMoney = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [approvalUrl, setApprovalUrl] = useState<string>('');

  const post = useCallback(async (request: { cardId: string; amount: number }) => {
    try {
      setLoading(true);
      setApprovalUrl('');
      const result = await ProfileApi.postc2cpaymenturl({
        cardId: request.cardId,
        amount: request.amount * 100,
        ipAddress: '127.0.0.1',
        userAgent: navigator.userAgent,
      });

      if (result && result.details) setApprovalUrl(result.details.approvalUrl);
    } finally {
      setLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setApprovalUrl('');
  }, []);

  return {
    loading,
    post,
    reset,
    approvalUrl,
  };
};

export const useFeeFactor = () => {
  const [feeFactor, setFeeFactor] = useState<number>();

  const getFeeFactor = useCallback(async () => {
    const result = await ProfileApi.getc2cfeepercent();
    setFeeFactor(result * 0.01);
  }, []);

  return {
    getFeeFactor,
    feeFactor,
  };
};
